import React from 'react';
import { Link } from 'react-router-dom';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { Footer, Header } from '../Common';
import { SearchBox } from '../Common/SearchBox';
import Pagination from "react-js-pagination";
import { AffiliatorDashboardHeader } from '../Common/AffiliatorDashboardHeader';
import AffiliatorLinks from '../../Models/AffiliatorLinks';
import Affiliator from '../../Models/Affiliator';
// import "../../../bootstrap/dist/sass/bootstrap.sass";
import "bootstrap/scss/bootstrap.scss";
import "bootstrap/scss/bootstrap.scss";
// import "bootstrap/less/bootstrap.less";
class SalesManagement extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert('ログインしてください')
            window.location.href = '/login/affiliator';
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            itemsCountPerPage: 10,
            pageRangeDisplayed: 5,
            total: [],
            activePage: 1,
            productsList: [],
            user: logged_user,
            searchkey: ''
        }
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handlePageChange(pageNumber) {
        var s = JSON.parse(window.localStorage.getItem('info'));
        AffiliatorLinks.getAffsoldProductsCommission(s.id, pageNumber).then(res => {
            if (res.data.payload != null) {
                console.log(`active page is ${pageNumber}`);
                this.setState({ productsList: res.data.payload, activePage: pageNumber, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage });
            }
        })
    }

    componentWillMount() {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            AffiliatorLinks.getAffsoldProductsCommission(x.id, 1).then(res => {
                if (res.data.payload != null) {
                    this.setState({ productsList: res.data.payload, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
                }
            })
        }
    }

    handleSubmit(e) {
        e.preventDefault()
        let data = {
            'searchkey': this.state.searchkey,
            'aff': this.state.user.id
        }
        Affiliator.sendAffliatorProductSearch(data).then(res => {
            if (res.data.status === 200) {
                this.setState({ productsList: res.data.payload })
            }
        })
    }

    affiliatorName(id, name) {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.id === id) {
                return (
                    <div className="">自己</div>
                )
            } else {
                return (
                    <div className="">{name}</div>
                )
            }
        }
    }

    pagination() {
        if (this.state.total >= 5) {
            return (
                <div className="col-md-12">
                    <Pagination
                        hideNavigation
                        activePage={this.state.activePage}
                        itemsCountPerPage={this.state.itemsCountPerPage}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={this.state.pageRangeDisplayed}
                        onChange={this.handlePageChange.bind(this)}
                    />
                </div>

                // </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-4 input_name small-hidden">
                                <AffiliatorSidebar />
                            </div>
                            <div className="col-md-8">
                                <div className="mb-3 input_name big_font guide_text pages_headers" style={{ width: "100%", fontSize: '20px' }}>
                                    アフィリエイト報酬
                                </div>
                                {/* <div className="col-md-8 mr-5 pr-5 mb-3">
                                    <div className="search_area" >
                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                            <div className="row">
                                                <div className="col-md-9" style={{ paddingRight: '0px' }}>
                                                    <input type="text" placeholder="" onChange={this.updateValue.bind(this, "searchkey")} value={this.state.searchkey} />
                                                </div>
                                                <div className="col-md-3">
                                                    <button type="submit" style={{ border: '1px solid #ccc', backgroundColor: 'white', width: '40px', height: '30px' }}><i className="fas fa-search"></i></button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div> */}
                                {(() => {
                                    if (this.state.productsList.length > 0) {
                                        return (
                                            <div className=""></div>
                                        )
                                    }
                                })()}
                                {(() => {
                                    if (this.state.productsList.length > 0) {
                                        return (
                                            <div className="">
                                                {this.state.productsList.map((group, i = 1) =>
                                                    <div className="row">
                                                        <div className="col-md-1 small-hidden">
                                                            <span><b><i>{++i}</i></b></span>
                                                        </div>
                                                        <div className="col-md-11">
                                                            <div className="row">
                                                                <div className="col-md-2 small-hidden">
                                                                    <span><i>サービス名</i></span>
                                                                </div>
                                                                <div className="col-md-8" style={{ fontSize: '14px' }}>
                                                                    <Link to={{ pathname: `/categories-details/${group.product_id}`, state: { id: group.product_id } }} className=""><span>{group.title}</span></Link>
                                                                </div>
                                                                <div className="col-md-2" style={{ fontSize: '12px' }}>
                                                                    <span>{(JSON.stringify(group.created_at)).substring(1, 11)}</span>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-3">氏名</div>
                                                                <div className="col-9">{group.root_aff}</div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-3">レート</div>
                                                                <div className="col-9">{parseInt(group.percent) / 2}  %</div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-3">報酬</div>
                                                                <div className="col-9">{parseInt(group.earning_amount)} 円</div>
                                                            </div>
                                                            <hr />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    }
                                })()}
                                <div className="text-center row">
                                    <div className="col-md-4"></div>
                                    <div className="col-md-8">
                                        {this.pagination()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name small-hidden">
                                        <AffiliatorSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-3 input_name big_font guide_text pages_headers" style={{ width: "100%" }}>
                                            アフィリエイト報酬
                                        </div>
                                        {(() => {
                                            if (this.state.productsList.length > 0) {
                                                return (
                                                    <div className=""></div>
                                                )
                                            }
                                        })()}
                                        {(() => {
                                            if (this.state.productsList.length > 0) {
                                                return (
                                                    <div className="">
                                                        {this.state.productsList.map((group, i = 1) =>
                                                            <div className="row">
                                                                <div className="col-md-1 small-hidden">
                                                                    <span><b><i>{++i}</i></b></span>
                                                                </div>
                                                                <div className="col-md-11">
                                                                    <div className="row">
                                                                        <div className="col-md-2 small-hidden">
                                                                            <span><i>サービス名</i></span>
                                                                        </div>
                                                                        <div className="col-md-8" style={{ fontSize: '14px' }}>
                                                                            <Link to={{ pathname: `/categories-details/${group.product_id}`, state: { id: group.product_id } }} className=""><span>{group.title}</span></Link>
                                                                        </div>
                                                                        <div className="col-md-2" style={{ fontSize: '12px' }}>
                                                                            <span>{(JSON.stringify(group.created_at)).substring(1, 11)}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="">
                                                                        <span><i style={{ marginRight: "54px" }}>アフィリエイター名</i></span>
                                                                        <span>{group.root_aff}</span>
                                                                    </div>
                                                                    <div className="">
                                                                        <span><i style={{ marginRight: "54px" }}>コミッションレート</i></span>
                                                                        <span>{parseInt(group.percent) / 2}  %</span>
                                                                    </div>
                                                                    <div className="">
                                                                        <span style={{ marginRight: "33px" }}><i>アフィリエイト報酬</i> &nbsp;</span> &nbsp;&nbsp;
                                                                            <span>{parseInt(group.earning_amount)} 円</span>
                                                                    </div>

                                                                    <hr />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                    // <table className="table_individual ml-3">
                                                    //     <tbody>
                                                    //         {this.state.productsList.map(group =>
                                                    //             <tr>
                                                    //                 <td style={{ width: '25%' }}>
                                                    //                     <Link to={{
                                                    //                         pathname: `/categories-details/${group.product_id}`,
                                                    //                         state: { id: group.product_id }
                                                    //                     }} className="individual_title_text text-left" style={{ textDecoration: 'none' }}>
                                                    //                         {group.title}...
                                                    //                                 </Link>
                                                    //                     {/* {group.title} */}
                                                    //                 </td>
                                                    //                 <td style={{ width: '20%' }}>
                                                    //                     {this.affiliatorName(group.root_selling_aff, group.root_aff)}
                                                    //                     {/* {group.parent} */}
                                                    //                 </td>
                                                    //                 <td style={{ width: '20%' }}>
                                                    //                     {parseInt(group.percent)}
                                                    //                 </td>
                                                    //                 <td style={{ width: '20%' }}>
                                                    //                     {group.earning_amount}
                                                    //                 </td>
                                                    //                 <td style={{ width: '15%' }}>
                                                    //                     {(JSON.stringify(group.created_at)).substring(1, 11)}
                                                    //                 </td>
                                                    //             </tr>
                                                    //         )}
                                                    //     </tbody>
                                                    // </table>
                                                )
                                            }
                                            // else {
                                            //     return (
                                            //         <div className="mt-5">データありません！</div>
                                            //     )
                                            // }
                                        })()}
                                        <div className="text-center row">
                                            <div className="col-md-2"></div>
                                            <div className="col-md-8">

                                                {this.pagination()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <Footer />
                </div>
            )
        }
    }
}
export { SalesManagement }